<template>
  <div class="app-main-page" :style="{ height: (window ?'100%':'') }">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" label-width="50px" label-position="left">
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height:300px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :side-bar="sideBarDefs"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
        @gridReady="onGridReady"
      />
    </div>
    <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
  </div>
</template>

<script>

import { getAllTemplateLocation } from '@/api/location'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'BaseCity',
  components: { },
  props: {
    window: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        isRowSelectable: function(row) {
          return row.data && !row.data.isAdded
        },
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.city.code'),
          field: 'code',
          suppressMenu: true
        }, {
          headerName: this.$t('baseInfo.city.chineseName'),
          field: 'chineseName',
          suppressMenu: true
        }, {
          headerName: this.$t('baseInfo.city.englishName'),
          field: 'englishName',
          suppressMenu: true
        }, {
          headerName: this.$t('baseInfo.city.locationCode'),
          field: 'locationCode',
          suppressMenu: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryName',
          suppressMenu: true
        }, {
          headerName: this.$t('baseInfo.city.lon'),
          field: 'lon',
          width: 200
        }, {
          headerName: this.$t('baseInfo.city.lat'),
          field: 'lat',
          width: 200
        },
        {
          headerName: this.$t('common.tips.isAdded'),
          field: 'isAdded',
          suppressMenu: true,
          cellRenderer: params => {
            const iconName = !params.value ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.value ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          }
        }
      ],
      rowData: [],
      gridApi: null,
      countryList: []
    }
  },
  created() {
    const self = this
    self.countryList = document.countryList
    document.resetBaseCity = function() {
      self.toQuery()
    }
    document.getSelectedBaseCityRows = function() {
      return self.gridApi.getSelectedRows()
    }
  },
  beforeDestroy() {
    document.resetBaseCity = null
    document.getSelectedBaseCityRows = null
  },
  methods: {
    onGridReady(params) {
      const self = this
      self.gridApi = params.api
      self.onGridDateRendered()
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getAllTemplateLocation(self.filter).then(res => {
        self.bindCountryName(res.data.list)
        for (const item of res.data.list) {
          item.isAddedStr = item.isAdded ? this.$t('common.tips.yes') : this.$t('common.tips.no')
        }
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
        self.onGridDateRendered()
      }).finally(() => { loading.close() })
    },
    onGridDateRendered() {
      const self = this
      const columnApi = self.gridApi.columnController.columnApi
      const columnIds = []
      self.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    },
    bindCountryName(data) {
      if (this.countryList.length === 0 || data.length === 0) {
        return
      }
      if (data[0].countryName) {
        return
      }
      const map = new Map()
      for (const item of this.countryList) {
        map.set(item.code, item.countryName)
      }
      for (const item of data) {
        item.countryName = map.get(item.countryCode)
      }
    }
  }
}
</script>

<style>
</style>
